export const PAUSE_REASONS = [
    "Checked Out",
    "Team Meeting",
    "Lunch Break",
    "Tech Issue",
    "Client Wait",
    "Research Task",
    "Out Office",
    "Review Hold",
    "Different Project",
    "Other",
];

/** Shorter set for staff mobile pause flow */
export const STAFF_PAUSE_REASONS = [
    "Lunch break",
    "Guest waiting",
    "Need supplies",
    "Equipment issue",
    "Other",
];

export const PRIORITY_OPTIONS = [
    { value: "critical", label: "Critical", className: "text-error border-error/60 bg-error/20" },
    { value: "high", label: "High", className: "text-error border-error/40 bg-error/10" },
    { value: "medium", label: "Medium", className: "text-warning border-warning/40 bg-warning/10" },
    { value: "low", label: "Low", className: "text-info border-info/40 bg-info/10" },
];

export const REPEAT_OPTIONS = [
    { value: "none", label: "Does not repeat" },
    { value: "daily", label: "Daily" },
    { value: "weekdays", label: "Weekdays" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "annually", label: "Yearly" },
    { value: "custom", label: "Custom…" },
];

export { REMINDER_OPTIONS, REPEAT_OPTIONS_EXTENDED } from "./utils/taskReminderSync";

/** Kanban columns for the tasks board. */
export const TASK_BOARD_COLUMNS = [
    { key: "Open", label: "Open", accent: "#3b82f6" },
    { key: "In Progress", label: "In Progress", accent: "#f59e0b" },
    { key: "Paused", label: "Paused", accent: "#9ca3af" },
    { key: "Blocked", label: "Blocked", accent: "#ef4444" },
    { key: "Cancelled", label: "Cancelled", accent: "#6b7280", isClosed: true },
    { key: "Completed", label: "Completed", accent: "#10b981", isClosed: true },
];

export function isTaskPaused(task) {
    return (
        task?.paused === true ||
        task?.paused === 1 ||
        task?.paused === "true" ||
        task?.paused === "1"
    );
}

export function taskBoardColumnKey(task) {
    const status = String(task?.status || "").trim().toLowerCase();
    if (status === "completed") return "Completed";
    if (status === "cancelled") return "Cancelled";
    if (status === "blocked") return "Blocked";
    if (isTaskPaused(task)) return "Paused";
    if (status === "in progress") return "In Progress";
    return "Open";
}

export function applyBoardColumn(task, columnKey) {
    if (columnKey === "Completed") {
        return { ...task, status: "Completed", paused: false };
    }
    if (columnKey === "Cancelled") {
        return { ...task, status: "Cancelled", paused: false, completed: false };
    }
    if (columnKey === "Paused") {
        return {
            ...task,
            paused: true,
            status: String(task.status || "").toLowerCase() === "completed" ? "In Progress" : task.status,
        };
    }
    return { ...task, status: columnKey, paused: false };
}
